import type { HTMLAttributes, ReactNode } from "react"
import { cn } from "@/lib/utils"

type TransmissionPanelProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}

export function TransmissionPanel({
  children,
  className,
  ...rest
}: TransmissionPanelProps) {
  return (
    <div
      {...rest}
      className={cn(
        "border border-white/15 bg-background/45 p-6 shadow-[0_0_60px_rgb(var(--brand-rgb)/0.05)] backdrop-blur-sm sm:p-7",
        className
      )}
    >
      {children}
    </div>
  )
}
